import { getFontStyle } from '@diversioteam/diversio-ds'
import styled from 'styled-components'

export const EmailTemplatesWrapper = styled.div`
    grid-area: email-templates;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 30px;
    border-radius: 15px;
    border: 1.5px solid ${({ theme }) => theme.colors.primaryGray2};
`

export const Header = styled.header`
    display: flex;
    flex-direction: column;
    gap: 8px;
`

export const Title = styled.h3`
    margin: 0;
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${({ theme }) => theme.colors.primary90};

    ${getFontStyle('p01Semibold')}
`

export const Description = styled.p`
    margin: 0;
    color: ${({ theme }) => theme.colors.secondary500};

    ${getFontStyle('p02Regular')}
`

export const TemplatesList = styled.ul`
    margin: 0;
    padding: 0;
    list-style-type: none;
    display: flex;
    flex-direction: column;
`

export const TemplatesListItem = styled.li`
    margin: 0;
    padding: 0;
`
